import React from 'react';
import { cn } from '../../lib/utils';

export const CurrencyToggle = ({ value, onChange, className }) => {
  return (
    <div className={cn("flex items-center gap-1 bg-slate-100 rounded-lg p-1", className)}>
      <button
        type="button"
        onClick={() => onChange('ARS')}
        className={cn(
          "px-3 py-1 rounded text-sm font-medium transition-colors duration-200",
          value === 'ARS' 
            ? "bg-[#1B4D3E] text-white" 
            : "text-slate-600 hover:text-slate-900"
        )}
        data-testid="currency-ars-btn"
      >
        ARS
      </button>
      <button
        type="button"
        onClick={() => onChange('USD')}
        className={cn(
          "px-3 py-1 rounded text-sm font-medium transition-colors duration-200",
          value === 'USD' 
            ? "bg-[#1B4D3E] text-white" 
            : "text-slate-600 hover:text-slate-900"
        )}
        data-testid="currency-usd-btn"
      >
        USD
      </button>
    </div>
  );
};

export default CurrencyToggle;
